import {Typography} from '@yandex-delivery/ui'
import {tag2url} from '@yandex-delivery/utils'

import type {Message as MessageType} from '../../../../api'
import {Paper} from '../../../../components/ui'
import styleClasses from './classes@desktop.module.css'

type Props = {
  message: MessageType
}

export function Message({message}: Props) {
  const {title, subtitle, icon} = message

  return (
    <Paper>
      <div className={styleClasses.message}>
        {icon && <img alt={icon} className={styleClasses.icon} src={tag2url(icon)} />}
        <div className={styleClasses.messageContent}>
          <Typography density="normal" level="title4" weight="medium">
            {title}
          </Typography>
          {subtitle && (
            <Typography density="normal" level="body2" weight="regular">
              {subtitle}
            </Typography>
          )}
        </div>
      </div>
    </Paper>
  )
}
